import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import * as dayjs from 'dayjs';
import { Observable, of, Subscription } from 'rxjs';
import sanitizeForUrl from '../../../../utils/sanitizeForUrl';
import { HolidaySearchParams } from '../../../booking-flow/holiday/holiday-search-page/interfaces/holiday-search-params';
import { Occupancy } from '../../../shared/interfaces/occupancy';
import { BookingService } from '../../../shared/services/booking.service';
import { HolidayPrefetchService } from '../../../shared/services/holiday-prefetch.service';
import { MappingService } from '../../../shared/services/mapping.service';
import { PostMessageService } from '../../../shared/services/post-message.service';
import { ProjectService } from '../../../shared/services/project.service';
import { WidgetService } from '../../../shared/services/widget.service';
import { IDestinationBoxElement } from '../../interfaces/idestination-box-element';
import { IEngineParamChange } from '../../interfaces/iengine-param-change';
import { EngineTabTypes } from '../../models/engine-tab-types.enum';
import { HolidayEngineService } from '../../services/holiday-engine.service';
import {LoadingService} from '../../../shared/services/loading.service';
import {LoadingItem} from '../../../shared/interfaces/loading-item';

@Component({
  selector: 'app-engine-holiday',
  templateUrl: './engine-holiday.component.html',
  styleUrls: ['./engine-holiday.component.scss']
})
export class EngineHolidayComponent implements OnInit, OnDestroy, OnChanges {

  @Input() holidaySearchParams: HolidaySearchParams;
  @Input() engineTabType: EngineTabTypes;
  engineTabTypes = EngineTabTypes;
  onlyNetQuotes: Observable<boolean>;
  onlyCustomHoliday: Observable<boolean>;
  isB2B$: Observable<boolean>;

  constructor(private _holidayPrefetchService: HolidayPrefetchService,
              private _holidayEngineService: HolidayEngineService,
              private _mappingService: MappingService,
              private _widgetService: WidgetService,
              private _projectService: ProjectService,
              private _loadingService: LoadingService,
              private _bookingService: BookingService,
              private _postMessageService: PostMessageService,
              private _router: Router) { }

  selectedDestination: IEngineParamChange<IDestinationBoxElement>;
  selectedAirport: IEngineParamChange<(number | string)[]>;
  selectedDate: IEngineParamChange<NgbDateStruct>;
  selectedOccupancy: IEngineParamChange<Occupancy>;

  selectedDateString: string;

  aiportSubscription: Subscription;
  widgetSubscription: Subscription;

  ngOnInit(): void {
    this.isB2B$ = this._postMessageService.isB2B();
    this.selectedOccupancy = {value: this._bookingService.occupancy, resetParams: false};
  }

  onInputSelection(): void {
    this.widgetSubscription = this._widgetService.isWidget().subscribe(e => {
      if (!e) {
        document.querySelector('#searchEngine').scrollIntoView();
      }
    });
    this.widgetSubscription.unsubscribe();
  }

  onSelectedDestination(selectedDestination: IEngineParamChange<IDestinationBoxElement>): void {
    this.selectedDestination = selectedDestination;
  }

  onSelectedAirport(selectedAirport: IEngineParamChange<(number | string)[]>): void {
    this.selectedAirport = selectedAirport;
  }

  onSelectedDate(selectedDate: IEngineParamChange<NgbDateStruct>): void {
    this.selectedDate = selectedDate;

    // salvo nella proprietà dedicata, la stringa della data selezionata da passare al calendar in modo da selezionare il giorno
    // con un "active"
    // NB: viene passata in stringa dato che, il parametro del componente con il calendar, accetta solo date in stringa a causa del
    // fatto che lo stesso parametro, viene usato pure per passare la data in stringa proveniente dalla rotta
    if (this.selectedDate?.value) {
      this.selectedDateString = `${this.selectedDate.value.year}-${String(this.selectedDate.value.month).padStart(2, '0')}-${String(this.selectedDate.value.day).padStart(2, '0')}`;
    }
  }

  searchHoliday(): void {
    const loadingItem: LoadingItem = {id: 'cruise-pre-search', message: 'Caricamento in corso...'};
    const dateFormat = dayjs(`${this.selectedDate.value.year}-${this.selectedDate.value.month}-${this.selectedDate.value.day}`).format('DD-MM-YYYY');
    const occupancyString = this._bookingService.getAgesString();
    const selectedAirport = this.selectedAirport.value?.length > 0 ? this.selectedAirport.value[0] : undefined;
    const stringAirportsId = this.selectedAirport.value?.length > 0 ? this.selectedAirport.value.join(',') : undefined;
    this._loadingService.addLoad(loadingItem);
    this.aiportSubscription = this._mappingService.getAirportByID(selectedAirport).subscribe(e => {
      const airportOrHarbourName = (e?.Name) ? sanitizeForUrl(e.Name) : 'nessuno';
      const route = `/${this.engineTabType}/ricerca/${this.selectedDestination.value.id}/${stringAirportsId}/destinazione/${sanitizeForUrl(this.selectedDestination.value.name)}/aeroporto/${airportOrHarbourName}/il/${dateFormat}/eta/${occupancyString}`;
      this._loadingService.removeLoad(loadingItem);
      this._router.navigate([route]);
    });
  }

  ngOnDestroy(): void {
    this.aiportSubscription?.unsubscribe();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.engineTabType && this.engineTabType) {
      this.onlyCustomHoliday = of(false);
      this.onlyNetQuotes = this._projectService.hasOnlyNetQuotes();
    }
  }

}
